/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTimeOff = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        reason: {
    type: 'string',
    isNullable: true,
},
        status: {
    type: 'TimeOffStatus',
    isRequired: true,
},
        rejectReason: {
    type: 'string',
    isNullable: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};